import React from 'react';
import { cancelButton, save, Text } from '../../app-components';
import { ROUTES } from '../../Lib/constants';
import EmployeeData from './EmployeeData';
import AddEmployee from './AddEmployee';
import EditEmployee from './EditEmployee';
import vars from '../../theme/vars';
import FtsSearch from '../../Components/TableFilters/FtsSearch';
import { IconButton } from '../../app-components/buttons/Buttons';
import { addIcon } from '../../images';

const { headings } = vars;
const textStyle = { ...headings.pageHeading, marginLeft: 12 };

export default {
  [ROUTES.employeeData.name]: {
    screen: EmployeeData,
    expanded: true,
    title: () => <Text style={textStyle}>Manage Employees</Text>,
    headerActions: [
      (props) => (
        <FtsSearch
          {...props}
          action={{
            exp: ['username', 'firstName', 'lastName'],
          }}
        />
      ),
      {
        render: () => (
          <IconButton
            icon={addIcon}
            tooltipId="add-new-employee"
            description="Add New Employee"
            label="Add Employee"
            labelStyle={{
              fontSize: 18,
              color: '#ffffff',
              fontFamily: 'Mulish-SemiBold',
            }}
          />
        ),
        type: 'link',
        link: () => ({
          view: ROUTES.addEmployee.name,
          push: true,
          expanded: true,
        }),
      },
    ],
  },

  [ROUTES.addEmployee.name]: {
    screen: AddEmployee,
    expanded: true,
    title: () => <Text style={textStyle}>Add Employee</Text>,
    headerActions: [cancelButton, save],
  },

  [ROUTES.ViewEmployee.name]: {
    screen: EditEmployee,
    screenProps: {
      editable: true,
      type: 'standard',
      visible: false,
      fromView: true,
    },
    expanded: true,
    title: () => <Text style={textStyle}>Employee</Text>,
    headerActions: [cancelButton, save],
  },
};
